import React, { useState } from "react";
import { Box, Button, TextField, Typography } from "@mui/material";

const Composer = ({ onSubmit, placeholder }) => {
  const [body, setBody] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    const trimmed = body.trim();
    if (!trimmed || submitting) return;
    setSubmitting(true);
    try {
      await Promise.resolve(onSubmit(trimmed));
      setBody("");
    } catch {
      // keep draft on failure
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box sx={{ display: "grid", gap: 1, mt: 1 }}>
      <TextField
        size="small"
        multiline
        minRows={2}
        value={body}
        onChange={(event) => setBody(event.target.value)}
        placeholder={placeholder}
        inputProps={{ maxLength: 400 }}
      />
      <Button
        size="small"
        variant="outlined"
        disabled={!body.trim() || submitting}
        onClick={handleSubmit}
      >
        Post comment
      </Button>
    </Box>
  );
};

const Node = ({ comment, onReply }) => {
  const [replying, setReplying] = useState(false);
  if (comment.deleted) {
    return (
      <Typography color="text.secondary" sx={{ py: 1 }}>
        Comment removed
      </Typography>
    );
  }
  return (
    <Box sx={{ py: 1 }}>
      <Typography variant="subtitle2">{comment.user?.username}</Typography>
      <Typography variant="body2">{comment.body}</Typography>
      {onReply && (
        <Button size="small" onClick={() => setReplying(true)}>
          Reply
        </Button>
      )}
      {replying && (
        <Composer
          placeholder="Reply"
          onSubmit={async (body) => {
            await Promise.resolve(onReply(body));
            setReplying(false);
          }}
        />
      )}
      {(comment.replies || []).map((reply) => (
        <Box key={reply.id} sx={{ pl: 2 }}>
          <Node comment={reply} />
        </Box>
      ))}
    </Box>
  );
};

const DebateThread = ({ comments, onComment, canComment }) => (
  <Box sx={{ mt: 3 }}>
    <Typography variant="h6" fontWeight={800}>
      Discussion
    </Typography>
    {(comments || []).map((comment) => (
      <Node
        key={comment.id}
        comment={comment}
        onReply={canComment ? (body) => onComment(body, comment.id) : undefined}
      />
    ))}
    {canComment && (
      <Composer placeholder="Add a take (optional)" onSubmit={(body) => onComment(body)} />
    )}
  </Box>
);

export default DebateThread;
